import MVT from 'ol/format/MVT.js';
import Map from '@planet/maps/Map';
import OSM from '@planet/maps/source/OSM';
import PropTypes from 'prop-types';
import React, {useCallback, useEffect, useRef} from 'react';
import TileLayer from '@planet/maps/layer/WebGLTile';
import VectorTileLayer from '@planet/maps/layer/VectorTile';
import VectorTileSource from '@planet/maps/source/VectorTile';
import View from '@planet/maps/View';
import {GRANERO_BASE_URL} from '@account/config';
import {useAuth} from '@apps-common/auth-react';

const mvtFormat = new MVT();

const tileLoader = (tile, url, token) => {
  tile.setLoader((extent, resolution, featureProjection) => {
    fetch(url, {
      headers: {Authorization: `Bearer ${token}`},
    }).then(resp => {
      resp.arrayBuffer().then(buf => {
        tile.setFeatures(
          tile.getFormat().readFeatures(buf, {
            extent,
            featureProjection,
          })
        );
      });
    });
  });
};

const BoundaryMap = ({collection}) => {
  const auth = useAuth();
  const mapRef = useRef();

  const zoomToExtent = useCallback(extent => {
    const mapView = mapRef?.current.getView();

    mapView.fit(extent, {
      duration: 800,
      padding: [12, 12, 12, 12],
    });
  }, []);

  useEffect(() => {
    if (collection?.feature_count > 0 && collection?.extent) {
      zoomToExtent(collection.extent?.spatial?.bbox[0]);
    }
  }, [collection, zoomToExtent]);

  return (
    <Map ref={mapRef}>
      <View options={{center: [0, 0], zoom: 1}} />
      <TileLayer>
        <OSM />
      </TileLayer>
      {!!collection && (
        <VectorTileLayer>
          <VectorTileSource
            url={`${GRANERO_BASE_URL}/features/v1/ogc/boundaries/collections/${collection?.id}/tiles/{z}/{x}/{y}`}
            options={{
              format: mvtFormat,
              tileLoadFunction: (tile, url) =>
                tileLoader(tile, url, auth.user.accessToken),
            }}
          />
        </VectorTileLayer>
      )}
    </Map>
  );
};

BoundaryMap.propTypes = {
  collection: PropTypes.object,
};

export default BoundaryMap;
